<template>
  <div id="customer-list" v-loading="loading">
    <form class="row search-pannel" :class="{ fold: fold}" @submit.prevent="doLoad(true)">
      <input type="submit" style="display:none" />
      <div class="col-sm-3">
        <el-input size="small" v-model="query.name" placeholder="商户名称" />
      </div>
      <div class="col-sm-3">
        <el-input size="small" v-model="query.phone" placeholder="客户手机号" />
      </div>
      <div class="col-sm-3">
        <el-input size="small" v-model="query.address" placeholder="地址搜索" />
      </div>
      <div class="col-sm-3">
        <el-select size="small" v-model="query.brandCodes" placeholder="消费品牌" multiple>
          <el-option v-for="b in orderBrands" :label="b.name" :value="b.code" :key="b.code" />
        </el-select>
      </div>
      <!-- <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.registerTimeStart" placeholder="注册时间-起">
        </el-date-picker>
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.registerTimeEnd" placeholder="注册时间-止">
        </el-date-picker>
      </div> -->
      <div class="col-sm-3">
        <el-select size="small" v-model="query.lastActiveTime" placeholder="活跃情况" clearable>
          <el-option :value="1" label="7天未登录" />
          <el-option :value="2" label="15天未登录" />
          <el-option :value="3" label="30天未登录" />
        </el-select>
      </div>
      <div class="col-sm-3">
        <el-select size="small" v-model="query.lastExpirationTime" placeholder="服务包情况" clearable>
          <el-option :value="4" label="无服务" />
          <el-option :value="8" label="有服务" />
          <el-option :value="5" label="7天内服务到期" />
          <el-option :value="6" label="15天内服务到期" />
          <el-option :value="7" label="30天内服务到期" />
          <el-option :value="-13" label="已到期7天未续费" />
          <el-option :value="-14" label="已到期15天未续费" />
          <el-option :value="-15" label="已到期30天未续费" />
        </el-select>
      </div>
      <div class="col-sm-3 field">
        <el-select v-model="query.lastBuyTime" size="small" placeholder="配件购买情况" clearable>
          <el-option :value="9" label="7天内无购买配件" />
          <el-option :value="10" label="15天内无购买配件" />
          <el-option :value="11" label="30天内无购买配件" />
        </el-select>
      </div>
      <div class="col-sm-3 field">
        <el-select v-model="query.sortKey" size="small" placeholder="排序字段" clearable>
          <el-option v-for="s in sortMaps" :key="s.code" :label="s.name" :value="s.code" />
        </el-select>
      </div>
      <div class="folder">
        <el-button type="primary" size="small" @click="doLoad(true)">确定</el-button>
        <el-button type="default" size="small" @click="doReset">重置</el-button>
        <el-button type="warning" size="small" v-if="canExport" data-uac="customer.export$$客户管理.导出" @click="doExp">导出</el-button>
        <el-button v-else style="display: none;"></el-button>
        <el-button style="float: right" size="small" type="text" @click="fold = !fold">
          {{ fold ? '展开' : '收起' }}
          <i v-if="fold" class="crm-icon-arrow-down" />
          <i v-else class="crm-icon-arrow-up" />
        </el-button>
        <el-button style="float: right" size="small" type="text" @click="redirctToAdd">新增客户<i class="el-icon-plus" /></el-button>
      </div>
    </form>
    <div class="data-list">
      <template v-if="list && list.length">
        <div v-for="(item, idx) in list" :key="idx" class="customer-item-wraper">
          <customer-item :company="item" @reload="doLoad(false)" />
        </div>
      </template>
      <div v-else class="no-data" style="text-align: center; line-height: 120px">
        暂无数据~
      </div>
    </div>
    <div class="page-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size="pagination.pageSize"
        @current-change="doLoad(false)"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { loadCustomers, exportCustomer } from './services'
import CustomerItem from './partials/CustomerItem.vue'
import moment from 'moment'
export default {
  name: 'Customers',
  components: { CustomerItem },
  data () {
    return {
      loading: false,
      fold: true,
      list: [],
      pagination: {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      },
      query: {
        address: undefined,
        name: undefined,
        phone: undefined,
        brandCodes: [],
        registerTimeStart: undefined,
        registerTimeEnd: undefined,
        lastActiveTime: undefined,
        lastBuyTime: undefined,
        lastExpirationTime: undefined,
        sortKey: undefined
      },
      sortMaps: [
        {
          code: 0,
          name: '注册时间'
        },
        {
          code: 1,
          name: '最后活跃'
        },
        {
          code: 2,
          name: '配件消费'
        },
        {
          code: 3,
          name: '服务消费'
        }
      ]
    }
  },
  computed: {
    orderBrands () {
      return this.$store.state.orderBrands || []
    },
    canExport () {
      return this.$store.state.privileges.indexOf('customer.export') > -1
    }
  },
  watch: {
    newAdd () {
      this.doLoad(true)
    },
    area () {
      this.doLoad(true)
    }
  },
  async beforeMount () {
    if (!this.orderBrands.length) {
      await this.$store.dispatch('loadOrderBrands')
    }
  },
  mounted () {
    this.doLoad(true)
  },
  methods: {
    doExp () {
      const { name, phone, address, brandCodes, registerTimeStart, registerTimeEnd, lastActiveTime, lastBuyTime, lastExpirationTime, sortKey } = this.query
      let activeTimeOpt = {}
      if (lastActiveTime) {
        activeTimeOpt.lastActiveTime = this.calcDeadTime(lastActiveTime)
      }
      if (lastBuyTime) {
        activeTimeOpt.lastBuyTime = this.calcDeadTime(lastBuyTime)
      }
      if (lastExpirationTime) {
        console.log(lastExpirationTime)
        if (lastExpirationTime > 0) {
          activeTimeOpt.expirationTime = this.calcExpTime(lastExpirationTime)
          if (lastExpirationTime === 4) {
            activeTimeOpt.hasService = 0
          } else if (lastExpirationTime === 8) {
            activeTimeOpt.hasService = 1
          }
        } else {
          activeTimeOpt.hasService = 0
          activeTimeOpt.expiredTime = this.calcExpTime(lastExpirationTime)
        }
      }
      exportCustomer({
        brandCodes: brandCodes || [],
        sortKey: sortKey || undefined,
        name: name || undefined,
        phone: phone || undefined,
        address: address || undefined,
        registerTimeStart: registerTimeStart || undefined,
        registerTimeEnd: registerTimeEnd || undefined,
        ...activeTimeOpt,
        newAdd: this.newAdd,
        area: this.area || undefined
      })
    },
    calcDeadTime (typeNum) {
      let timeDead
      const mod = typeNum % 4
      switch (mod) {
        case 1: {
          timeDead = moment().subtract(7, 'days').format('YYYY-MM-DD'); break
        }
        case 2: {
          timeDead = moment().subtract(15, 'days').format('YYYY-MM-DD'); break
        }
        case 3: {
          timeDead = moment().subtract(30, 'days').format('YYYY-MM-DD'); break
        }
        default: timeDead = undefined; break
      }
      return timeDead
    },
    calcExpTime (typeNum) {
      let timeDead
      const mod = typeNum % 4
      switch (mod) {
        case 1: {
          timeDead = moment().add(7, 'days').format('YYYY-MM-DD'); break
        }
        case 2: {
          timeDead = moment().add(15, 'days').format('YYYY-MM-DD'); break
        }
        case 3: {
          timeDead = moment().add(30, 'days').format('YYYY-MM-DD'); break
        }
        case -1: {
          timeDead = moment().subtract(7, 'days').format('YYYY-MM-DD'); break
        }
        case -2: {
          timeDead = moment().subtract(15, 'days').format('YYYY-MM-DD'); break
        }
        case -3: {
          timeDead = moment().subtract(30, 'days').format('YYYY-MM-DD'); break
        }
        default: timeDead = undefined; break
      }
      return timeDead
    },
    doLoad (reload) {
      if (reload) {
        this.pagination.pageIndex = 1
      }
      this.loading = true
      const { pageIndex, pageSize } = this.pagination
      const { name, phone, address, brandCodes, registerTimeStart, registerTimeEnd, lastActiveTime, lastBuyTime, lastExpirationTime, sortKey } = this.query
      let activeTimeOpt = {}
      if (lastActiveTime) {
        activeTimeOpt.lastActiveTime = this.calcDeadTime(lastActiveTime)
      }
      if (lastBuyTime) {
        activeTimeOpt.lastBuyTime = this.calcDeadTime(lastBuyTime)
      }
      if (lastExpirationTime) {
        if (lastExpirationTime > 0) {
          activeTimeOpt.expirationTime = this.calcExpTime(lastExpirationTime)
          if (lastExpirationTime === 4) {
            activeTimeOpt.hasService = 0
          } else if (lastExpirationTime === 8) {
            activeTimeOpt.hasService = 1
          }
        } else {
          activeTimeOpt.hasService = 0
          activeTimeOpt.expiredTime = this.calcExpTime(lastExpirationTime)
        }
      }
      loadCustomers({
        pageIndex,
        pageSize,
        brandCodes: brandCodes || [],
        sortKey: sortKey || undefined,
        name: name || undefined,
        phone: phone || undefined,
        address: address || undefined,
        registerTimeStart: registerTimeStart || undefined,
        registerTimeEnd: registerTimeEnd || undefined,
        ...activeTimeOpt,
        newAdd: this.newAdd,
        area: this.area || undefined
      }).then(resp => {
        const { pageIndex, pageSize, totalCount, items } = resp
        this.list = items
        this.pagination = {
          pageIndex,
          pageSize,
          totalCount
        }
      }).finally(() => {
        this.loading = false
      })
    },
    doReset () {
      this.pagination = {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      }
      this.query = {
        address: undefined,
        name: undefined,
        phone: undefined,
        brandCodes: [],
        registerTimeStart: undefined,
        registerTimeEnd: undefined,
        lastActiveTime: undefined,
        sortKey: undefined
      }
      this.doLoad(true)
    },
    redirctToAdd () {
      this.$router.push('/customer/add')
    }
  }
}
</script>
